// extracted by mini-css-extract-plugin
export default {"imageWrapper":"RQ-z","hovered":"SQ-z","hoverImage":"TQ-z","mainImage":"UQ-z","imageNoBackground":"VQ-z","fullSizeImage":"WQ-z"};